export default "__VITE_ASSET__462d7fd3__"